import { C } from "../../lib/tokens.js";
import { splitLinks } from "../../lib/linkify.js";

// Renders plain text with http(s) URLs as links in a new tab. Everything else stays text (React escapes it).
export function Linkify({ text }) {
  return splitLinks(text).map((p, i) =>
    p.url ? (
      <a key={i} href={p.url} target="_blank" rel="noopener noreferrer" style={{ color: C.liquid }}>
        {p.text}
      </a>
    ) : (
      p.text
    )
  );
}
